import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { BulkAction } from '@api/orval/apiHooks'
import { QueryParam, QueryParams } from '@components/Filters/filter.types'
import { RootState } from '@store/store'

type FilterMetadataState = {
  [K in keyof QueryParams]: {
    count?: number
    options: Record<string, { value: string; label: string }[]>
    values?: QueryParam
    bulk_actions?: BulkAction[]
  }
}

const initialMetadataState: FilterMetadataState = {}

const EMPTY_OBJECT: QueryParam = {}

const filterMetadataSlice = createSlice({
  name: 'filterMetadata',
  initialState: initialMetadataState,
  reducers: {
    setFilterMetadata: (
      state,
      action: PayloadAction<{
        tab: keyof QueryParams
        count?: number
        options: Record<string, { value: string; label: string }[]>
        bulk_actions?: BulkAction[]
      }>,
    ) => {
      state[action.payload.tab] = {
        ...state[action.payload.tab],
        bulk_actions: action.payload.bulk_actions,
        count: action.payload.count,
        options: action.payload.options,
      }
    },

    setTabFilters: (
      state,
      action: PayloadAction<{ tab: keyof QueryParams; filters: QueryParams[keyof QueryParams] }>,
    ) => {
      const { tab, filters } = action.payload

      if (!state[tab]) {
        state[tab] = { options: {}, values: {} }
      }

      state[tab].values = {
        ...filters,
      }
    },

    resetTabFilters: (state, action: PayloadAction<keyof QueryParams>) => {
      const tab = action.payload
      if (state[tab]) {
        state[tab].values = {}
      }
    },

    resetAllFilterMetadata: () => initialMetadataState,
  },
})

export const selectFilterMeta = (area: keyof QueryParams) => (state: RootState) => state.filterMeta[area]

export const selectFilterCount = (area?: keyof QueryParams) => (state: RootState) =>
  area ? state.filterMeta[area]?.count : 0

export const selectTabFilters =
  (area: keyof QueryParams) =>
  (state: RootState): QueryParam =>
    state.filterMeta[area]?.values || EMPTY_OBJECT

export const { setFilterMetadata, setTabFilters, resetTabFilters, resetAllFilterMetadata } = filterMetadataSlice.actions

export const filterMetadataReducer = filterMetadataSlice.reducer
